<template>
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg9>
            <p class="table_card__head--title">Crear noticia</p>
              <v-breadcrumbs class="breadcums">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item
                  @click="$router.push({name: 'news'})"
                  class="breadcums__option"
                >
                  Noticias creadas
                </v-breadcrumbs-item>
                <v-breadcrumbs-item
                  disabled
                  class="breadcums__disable"
                >
                  Nueva noticia
                </v-breadcrumbs-item>
              </v-breadcrumbs>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <v-flex class="right mr-1">
              <button
                class="faccess_button px-5"
                :disabled="formIsInError ? true : false "
                @click="formIsInError ? '' : createNews()"
              >
                Crear
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__info">
        <v-layout row wrap>
        <v-flex xs6>
    <!--       <v-flex xs12 v-if="news.attributes.video_published">
            <span class="data_card_special__info--label_form">Url video</span>
            <input
              class="trainers__form--input_form"
              type="text"
              :style="news.attributes.url.length<=0&&activeErrorName?'border-bottom:2px solid red !important;background-color:#ef4b4b59':''"
              name="Name"
              @blur="activeErrorName=true"
              placeholder="Url del video"
              v-model="news.attributes.url">
          </v-flex> -->
          <!-- Fotos de la oferta -->
          <span
            v-if="news.attributes.video_published === false"
            class="table_card__info--label">Imagen</span>
          <div
            v-if="news.attributes.video_published === false"
            class="trainers__form--photo_container"
          >
            <label
              for="trainerPhoto"
              class="faccess_button buttom_shadow px-5">Examinar</label>
            <input
              id="trainerPhoto"
              type="file"
              accept="image/x-png,image/gif,image/jpeg"
              @change="onFileChange"
              name="logo">
            <p>{{photo_name=='manager'?'No se han seleccionado archivos':photo_name}}</p>
          </div>
     <!--      <v-flex xs12>
            <v-switch
              class="data_card_special__switch"
              :label="`Habilitar video`"
              @change="news.attributes.video_published === true ? news.attributes.url = '' : ''"
              v-model="news.attributes.video_published">
            </v-switch>
          </v-flex> -->
          <v-flex xs12>
            <span class="table_card__info--label">Título</span>
            <input
              class="faccess_input"
              type="text"
              :style="news.attributes.name.length<=0&&activeErrorName?'border:2px solid red !important;background-color:#ef4b4b15':''"
              name="Name"
              @blur="activeErrorName=true"
              placeholder="Título de la noticia"
              v-model="news.attributes.name">
          </v-flex>
          <v-flex xs12>
            <span style="display: block; margin-bottom: -22px;"
            class="table_card__info--label">Contenido</span><br>
            <ckeditor :editor="editor" v-model="news.attributes.description" :config="editorConfig"></ckeditor>
            <!-- <v-textarea
              name="Contenido"
              class="data_card_special__textarea"
              v-model="news.attributes.description"
              :style="news.attributes.description.length<=0&&activeErrorName?'border-bottom:2px solid red !important;background-color:#ef4b4b59':''"
            ></v-textarea> -->
          </v-flex>
       <!--    <v-flex xs12>
            <span class="data_card_special__info--label_form">Tipos de noticia</span>
            <v-select
              class="data_card_special__info--select_form"
              label="Tipo de locación"
              v-bind:items="news_types"
              :item-value="'text'"
              v-model="news.attributes.news_type"
              single-line
              bottom
              color = "blue bold"
            ></v-select>
          </v-flex> -->
          <v-flex xs12>
            <span style="display: block; margin-top: 30px;"
            class="table_card__info--label">Sedes</span>
            <v-select
              label="Selecciona"
              v-bind:items="locationslist"
              :item-text="'attributes.name'"
              :item-value="'id'"
              v-model="news.attributes.location_id"
              single-line
              bottom
              solo
              color="#1476FB"
            ></v-select>
          </v-flex>
          <v-flex xs12 >
            <span class="table_card__info--label">Categoría</span>
            <v-select
              label="Selecciona"
              v-bind:items="specialCategoriesList"
              :item-text="'attributes.name'"
              :item-value="'id'"
              v-model="news.attributes.special_category_id"
              single-line
              bottom
              solo
              color="#1476FB"
            ></v-select>
          </v-flex>

          <v-flex xs12>
            <span class="table_card__info--label">Fecha de vencimiento</span>
            <app-single-date-picker :solid="false" @filterQuery="changeDate($event)"></app-single-date-picker>
          </v-flex>

          <v-flex xs12>
            <v-switch
              class="data_card_special__switch"
              :label="`Visible para los usuarios`"
              color="#1476FB"
              v-model="news.attributes.visible_to_user">
            </v-switch>
          </v-flex>

          <v-flex xs12 style="display:flex;max-width:150%; width:150% !important; margin-top:50px;" v-if="fieldError.length>0" >
            <p style="color:red;font-size:15px">
            Complete para continuar: {{fieldError}}
            </p>
          </v-flex>

        </v-flex>

        <!-- Inicia tarjeta de la derecha -->
        <v-flex xs6 class="preview_item">
          <preview-new :items="news"></preview-new>
        </v-flex>
        <!-- Termina tarjeta de la derecha -->

      </v-layout>
      </div>
      <div class="table_card__footer">
        <button
          class="faccess_button px-5"
          :disabled="formIsInError ? true : false "
          @click="formIsInError ? '' : createNews()"
        >
          Crear
        </button>
      </div>

    </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import previewNew from '../../../shared/PreviewNew.vue';

export default {
  data(){
    return{
      news_types: ['Normal', 'Video','Titular'],
      manager_url_change: false,
      schedule_url_change: false,
      schedule_url: '',
      manager_url: '',
      photo_name: 'No se han seleccionado archivos',
      activeErrorName:false,
      locationslist: '',
      specialCategoriesList: '',
      fieldError:'',
      url_change: false,
      url:'https://s3-us-west-2.amazonaws.com/karrottsportlife/default_image.svg',
      news:{
        attributes:{
          special_category_id: '',
          expiration: '',
          location_id: '',
          name: '',
          publication_date: '',
          description: '',
          url: '',
          url_type: '',
          visible_to_user: false,
          news_type: 'Normal',
          video_published: false
          
        },
      },
      editor: ClassicEditor,
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'Link','Unlink',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'Outdent','Indent',
        /*     '|',
            'Blockquote',
            'insertTable', */
            '|',
            'undo',
            'redo'
          ]
        },
        image: {
          toolbar: [
            'imageStyle:full',
            'imageStyle:side',
            '|',
            'imageTextAlternative'
          ]
        },
        table: {
          contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
        },
        language: 'es'
      },

    }
  },
  components:{
    previewNew
  },
  mounted(){
    this.findSpecialCategories();
    // this.locationslist = this.getLocations();
    this.findLocations()
  },
  watch:{
    url(){
      this.url_change = true;
    },
    schedule_url(){
      // cl schedule_url
      if(this.schedule_url != ''){
        this.schedule_url_change = true;
      }
    },
    manager_url(){
      // cl manager_url
      if(this.manager_url != ''){
        this.manager_url_change = true;
      }
    }
  },
  computed:{
    formIsInError(){
      var ans=false
      let fields=[]
      if(!this.url_change && this.news.attributes.name.length==0){
        fields.push("'Imagen principal o Video'")
      }
      if(this.news.attributes.name.length==0){
        fields.push("'Nombre'");
      }
      if(this.news.attributes.description.length==0){
        fields.push("'Contenido'")
      }
      if(this.news.attributes.news_type.length==0){
        fields.push("'Tipo de noticia'")
      }
      if(this.news.attributes.location_id.length==0){
        fields.push("'Sede'")
      }
      if(this.news.attributes.special_category_id.length==0){
        fields.push("'Categoria'")
      }
      if(this.news.attributes.expiration.length==0){
        fields.push("'Fecha de vencimiento'")
      }
      if(this.scheduleIsInError){
        fields.push("''")
      }
      if(fields.length>0){
        if(fields.length==2){
          this.fieldError=fields.join(" y ")
        }else{
          this.fieldError=fields.join(" , ")
        }

        ans=true
      }else{
        this.fieldError=""
      }
      return ans
    },
    scheduleIsInError(){
      var ans=false
      if(this.errorOpening||this.errorEnding||this.spacesInError){
        ans=true
      }
      return ans
    },
  },
  methods:{
 
    changeDate(val){
      var vm = this
      vm.news.attributes.expiration = val
    },

    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      var name_field = ""+e.target.name
      if (name_field=='schedule') {
        this.schedule_url = URL.createObjectURL(files[0]);
      }else if(name_field=='manager'){
        this.manager_url = URL.createObjectURL(files[0]);
      } else {
        this.url = URL.createObjectURL(files[0]);
      }
      this.createImage(files[0], ""+e.target.name)
    },
    createImage (file, name_field) {
      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {

        if (name_field=='schedule') {
          vm.news.attributes.schedule_image = reader.result
        }else if(name_field=='manager'){
          vm.news.attributes.manager_image = reader.result
        } else {
          //vm.location.attributes.image = reader.result
          vm.news.attributes.url = reader.result
        }
        vm.photo_name=name_field
        // vm.location.attributes.image = reader.result
      }
    },
    
    findLocations(){
      try {
        this.$http.get('app/locations',{
            params:{
            company:{id:this.getCompany().id
          },
            headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}}}
          )
        .then(function(response){
          this.locationslist = response.body.data
          console.log('this.locationslist ', this.locationslist)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findSpecialCategories(){
      try {
        this.$http.get('app/special_categories/index',{
          headers:
          {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()},
          })
        .then(function(response){
          this.specialCategoriesList = response.body.data
          console.log('this.specialCategoriesList ', this.specialCategoriesList)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    createNews(){
      this.news.attributes.video_published === false ? this.news.attributes.url_type = 'img' : this.news.attributes.url_type = 'video'

      try {
        console.log('info desde create', this.news)
        this.$http.post('app/articles/create', { data: this.encrypt(this.news).toString() },
          {headers:
            {
             "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
            }
          })
        .then(function(response){
          console.log(response);
          this.$router.push({name: 'news'})
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          console.log(response);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        console.log(e);
        alert(e.message)
      }
    },

  } //closed methods
}
</script>
<style scoped>
.theme--light.v-text-field>.v-input__control>.v-input__slot:before{
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/news/normal/New_news.vue